import { Button, Typography } from '@mgmresorts/wcl-lab';
import React, { useContext } from 'react';

import { NavigationLink } from '../../../components/ui/Link';
import { useContent } from '../../../hooks/useContent';
import { useEvent } from '../../../utils/analytics/useEvent';
import { SignUpFormContext } from '../SignUpFormContext';

export function CTASection() {
  const trackEvent = useEvent();
  const { processSignUp, isLoading, canProcessSignUp } = useContext(SignUpFormContext);
  const { getContentByPath } = useContent();

  return (
    <>
      <Button
        sticky
        ariaLabel={getContentByPath('accountCreation.ctaSection.label')}
        disabled={isLoading || !canProcessSignUp}
        onClick={processSignUp}
        onKeyPress={e => {
          e.preventDefault();
          if (e.key === 'Enter') {
            processSignUp();
          }
        }}
        className='identity__form-submit'
        loading={isLoading}
      >
        <Typography>{getContentByPath('accountCreation.ctaSection.title')}</Typography>
      </Button>
      <NavigationLink
        className='identity__secondary-action center'
        path='/'
        onClick={async () => {
          await trackEvent(
            'identity – m life registration - back to sign in',
            'back to sign in',
            'mliferegbacktosignin',
            {},
            true,
          );
        }}
      >
        <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M12.85 4.95293L5.71004 12.1029H20.5V13.1029H5.71004L12.85 20.2529L12.15 20.9529L3.79004 12.6029L12.15 4.25293L12.85 4.95293Z'
            fill='#373AE5'
          />
        </svg>
        {getContentByPath('accountCreation.ctaSection.backToSignIn')}
      </NavigationLink>
    </>
  );
}

CTASection.displayName = 'CTASectionField';
